/**
 * Custom Loader Component
 * Shows DSL loader with custom progress (not tied to drei's useProgress)
 */

import React, { useRef, useEffect, useState } from 'react'

export function CustomLoader({ progress, dataInterpolation }) {
  const progressRef = useRef(0)
  const rafRef = useRef(0)
  const progressSpanRef = useRef(null)
  const [shown, setShown] = useState(true)
  const isMountedRef = useRef(true)

  const updateProgress = React.useCallback(() => {
    if (!progressSpanRef.current || !isMountedRef.current) return
    progressRef.current += (progress - progressRef.current) / 2
    if (progressRef.current > 0.95 * progress || progress === 100) progressRef.current = progress
    progressSpanRef.current.innerText = dataInterpolation(progressRef.current)
    if (progressRef.current < progress && isMountedRef.current) {
      rafRef.current = requestAnimationFrame(updateProgress)
    }
  }, [dataInterpolation, progress])

  useEffect(() => {
    isMountedRef.current = true
    updateProgress()
    return () => {
      isMountedRef.current = false
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current)
        rafRef.current = 0
      }
    }
  }, [updateProgress])

  // Hide loader when progress is 100
  useEffect(() => {
    let timer = null
    
    if (progress >= 100) {
      timer = setTimeout(() => {
        if (isMountedRef.current) {
          setShown(false)
        }
      }, 500)
    }
    
    return () => {
      if (timer) {
        clearTimeout(timer)
      }
    }
  }, [progress])

  if (!shown) return null

  return (
    <div style={styles.container}>
      <div>
        <div style={styles.image}>
          <center>
            <img src="./images/dslBrand/DSL Logo Light and Orange.png" style={{width:'256px'}} alt="DSL Logo" />
          </center>
        </div>
        <div style={styles.inner}>
          <div style={{ ...styles.bar, transform: `scaleX(${progress / 100})` }}></div>
          <span ref={progressSpanRef} style={styles.data} />
        </div>
      </div>
    </div>
  )
}

const styles = {
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: '#000000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'opacity 500ms ease',
    zIndex: 1000,
  },
  inner: {
    marginTop: '0.8em',
    width: 256,
    height: 4,
    background: '#303030',
    textAlign: 'center',
  },
  bar: {
    height: 4,
    width: '100%',
    background: '#ed1b30',
    transition: 'transform 200ms',
    transformOrigin: 'left center',
  },
  data: {
    display: 'inline-block',
    position: 'relative',
    fontVariantNumeric: 'tabular-nums',
    marginTop: '0.8em',
    color: '#f0f0f0',
    fontSize: '1em',
    fontFamily: '"IBM Plex Mono", "IBM Plex Mono", monospace',
    whiteSpace: 'nowrap',
  },
  image: {
    margin: 'auto',
    display: 'block',
  },
}

export default CustomLoader
